import { render, staticRenderFns } from "./GeneralSiesaReport.vue?vue&type=template&id=ded879d0"
import script from "./GeneralSiesaReport.vue?vue&type=script&lang=js"
export * from "./GeneralSiesaReport.vue?vue&type=script&lang=js"
import style0 from "./GeneralSiesaReport.vue?vue&type=style&index=0&id=ded879d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports